import { render, staticRenderFns } from "./daerahXstrataJR2.vue?vue&type=template&id=f43cab6e&scoped=true"
import script from "./daerahXstrataJR2.vue?vue&type=script&lang=js"
export * from "./daerahXstrataJR2.vue?vue&type=script&lang=js"
import style0 from "./daerahXstrataJR2.vue?vue&type=style&index=0&id=f43cab6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43cab6e",
  null
  
)

export default component.exports